import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router';
import Path from '@/views/path.vue';

const routes: Array<RouteRecordRaw> = [
  {
    path: '/:path',
    name: 'Path',
    component: Path,
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

export default router;
